import { ScatterPlotScalesConfig, MetricDatum } from '../../../types';
import {
  formatNumber,
  calculateYAxisWidth,
  calculateXAxisLabelSpacing,
  CHAR_WIDTH_PX,
  MINIMUM_TICK_WIDTH_STRAIGHT,
  X_AXIS_LABEL_ANGLE_STRAIGHT,
} from '../../../utils/chartUtils';

type ScatterPlotOptions = {
  data: MetricDatum[];
  scales?: ScatterPlotScalesConfig;
  xAxisKeys: string[];
  xAxisLabels?: string[];
  yAxisKeys: string[];
  yAxisLabels: string[];
};

export const useScatterPlot = ({
  data,
  scales,
  xAxisKeys,
  xAxisLabels,
  yAxisKeys,
  yAxisLabels,
}: ScatterPlotOptions) => {
  if (!yAxisKeys || !xAxisKeys || yAxisKeys.length === 0 || xAxisKeys.length === 0) {
    return {
      data: [],
      formatValue: () => '',
      hasMultipleSeries: false,
      xAxisKeys: xAxisKeys || [],
      xAxisLabels: xAxisLabels || [],
      xAxisLabelSpacing: () => 0,
      yAxisKeys: yAxisKeys || [],
      yAxisLabels: yAxisLabels || [],
      yAxisWidth: 0,
    };
  }

  const hasMultipleSeries = yAxisKeys.length > 1;
  const formatValue = (value: any) =>
    formatNumber({
      value,
      format: scales?.y?.tickFormat,
    });
  const yAxisWidth = calculateYAxisWidth(data, yAxisKeys, formatValue, CHAR_WIDTH_PX, MINIMUM_TICK_WIDTH_STRAIGHT);
  const xAxisLabelSpacing = (key: string | number) =>
    calculateXAxisLabelSpacing(data, key, CHAR_WIDTH_PX, X_AXIS_LABEL_ANGLE_STRAIGHT);

  // No data transformation needed - use original data with dynamic dataKeys
  return {
    data,
    formatValue,
    hasMultipleSeries,
    xAxisKeys,
    xAxisLabels: xAxisLabels || [],
    xAxisLabelSpacing,
    yAxisKeys,
    yAxisLabels,
    yAxisWidth,
  };
};
